var map = {
	"./about/about.module": [
		"./src/app/about/about.module.ts",
		"common",
		"about-about-module"
	],
	"./camera/camera.module": [
		"./src/app/camera/camera.module.ts",
		"camera-camera-module"
	],
	"./chat-room/chat-room.module": [
		"./src/app/chat-room/chat-room.module.ts",
		"chat-room-chat-room-module"
	],
	"./contact/contact.module": [
		"./src/app/contact/contact.module.ts",
		"contact-contact-module"
	],
	"./gps/gps.module": [
		"./src/app/gps/gps.module.ts",
		"gps-gps-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./kml/kml.module": [
		"./src/app/kml/kml.module.ts",
		"kml-kml-module"
	],
	"./list/list.module": [
		"./src/app/list/list.module.ts",
		"list-list-module"
	],
	"./motion/motion.module": [
		"./src/app/motion/motion.module.ts",
		"motion-motion-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./shopping/shopping.module": [
		"./src/app/shopping/shopping.module.ts",
		"shopping-shopping-module"
	],
	"./songlist/songlist.module": [
		"./src/app/songlist/songlist.module.ts",
		"common",
		"songlist-songlist-module"
	],
	"./test/test.module": [
		"./src/app/test/test.module.ts",
		"test-test-module"
	],
	"./todo/todo.module": [
		"./src/app/todo/todo.module.ts",
		"todo-todo-module"
	],
	"./youtubedownload/youtubedownload.module": [
		"./src/app/youtubedownload/youtubedownload.module.ts",
		"common",
		"youtubedownload-youtubedownload-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;